import { createSlice } from "@reduxjs/toolkit";
import {getAllSubscriptionPlanList,getActivationStatus,getAllTransactionListOfSubscriber,verifyCouponCode } from "./ThunkAction";
import { iSubscriptionPlanState, REDUCER_NAME } from "./Types";
const initialState: iSubscriptionPlanState = {
  isLoading: false,
  planList: [], 
  errorMessage: null,
  activationStatus:null,
  isVerifyCouponCode:null,
  subscriberTransactionList:[],
};

export const subscriptionPlanSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetSubscriptionPlanState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSubscriptionPlanList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllSubscriptionPlanList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.planList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getAllSubscriptionPlanList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Coupon data";
        state.isLoading = false;
      })
      //get activation status

      .addCase(getActivationStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getActivationStatus.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.activationStatus = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getActivationStatus.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Coupon data";
        state.isLoading = false;
      })
      
      //get all transaction list of subscriber
     
      .addCase(getAllTransactionListOfSubscriber.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllTransactionListOfSubscriber.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.subscriberTransactionList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getAllTransactionListOfSubscriber.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Coupon data";
        state.isLoading = false;
      })

      .addCase(verifyCouponCode.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(verifyCouponCode.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.isVerifyCouponCode = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(verifyCouponCode.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Coupon data";
        state.isLoading = false;
      })
  },
});

export const { resetSubscriptionPlanState } = subscriptionPlanSlice.actions;
export default subscriptionPlanSlice.reducer;
  